module.exports = __webpack_public_path__ + "img/mobi.a8768a73.jpg";